import React, { useState, useEffect } from 'react';
import {
  CssBaseline,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Fab,
  IconButton,
  Card,
  CardContent,
  Typography,
  CardActions,
  AppBar,
  Toolbar,
  Button,
  Switch,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { addUser, fetchUsers, updateUser } from '../../redux/actions/usersActions';
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddUserModal from '../college-dashboard/add-user';
import EditIcon from '@mui/icons-material/Edit';
import { useParams } from 'react-router-dom';
import { ReactComponent as Logo } from '../../assets/unimates_logo_paysage.svg';
import { useNavigate } from 'react-router-dom'; 


function UniversityDetails() {
  let { uid } = useParams();
  const navigate = useNavigate(); 

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [studentToEdit, setStudentToEdit] = useState(null);
  const [isToEdit, setIsToEdit] = useState(false);

  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.data);
  const loading = useSelector((state) => state.users.loading);

  const handleWindowSizeChange = () => {
    setIsMobile(window.innerWidth < 600);
  };

  useEffect(() => {
    dispatch(fetchUsers(uid));
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [dispatch, uid]);

  const handleAddUser = () => {
    setIsAddUserModalOpen(true);
  };

  const handleCloseAddUserModal = () => {
    setIsAddUserModalOpen(false);
    setIsToEdit(false);
    setStudentToEdit(null);
  };

  const handleSaveUser = async (data) => {
    console.log(data);
    console.log();
    try {
      if (isToEdit) {
        await dispatch(updateUser({ uid: data.id, updatedUserData: data }));
      } else {
        await dispatch(addUser(data));
      }
      await dispatch(fetchUsers(uid));
      if(isToEdit){
        toast.success('Utilisateur mis à jour avec succès', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }else{
        toast.success('Utilisateur ajouté avec succès', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
   
      setIsAddUserModalOpen(false);
      setIsToEdit(false);
      setStudentToEdit(null);

     
    } catch (error) {
      setIsAddUserModalOpen(false);
      setIsToEdit(false);
      setStudentToEdit(null);

      toast.error("Erreur lors de l'ajout d'un utilisateur", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  const handleEditStudent = (user) => {
    setIsToEdit(true);
    setStudentToEdit(user);
    setIsAddUserModalOpen(true);
  };

  const handleActivateStudent = async (student) => {
    console.log(student);
    var updatedStudent = {
      ...student,
      isActive: true
    };
    await dispatch(updateUser({ uid: student.id, updatedUserData: updatedStudent }));
    await dispatch(fetchUsers(uid));
  };

  const handleDeactivateStudent = async (student) => {
    var updatedStudent = {
      ...student,
      isActive: false
    };
    await dispatch(updateUser({ uid: student.id, updatedUserData: updatedStudent }));
    await dispatch(fetchUsers(uid));
  };


  return (
    <div>
      <AppBar position="static"   style={{ backgroundColor: '#FC6258', width: '100%' }}>
        <Toolbar>
        <Button onClick={()=>{ navigate('/dashboard-admin', { replace: true }); }} color="inherit">RETOUR</Button>
          <div style={{ marginLeft: 'auto' }}>
            <Logo style={{ width: '140px', height: 'auto' }} />
          </div>
        </Toolbar>
      </AppBar>

      <div >
        <CssBaseline />
        <Fab
          color="primary"
          aria-label="add"
          style={{
            position: 'fixed',
            backgroundColor: '#FC6258',
            bottom: '16px',
            right: '16px',
          }}
          onClick={handleAddUser}
        >
          <AddIcon style={{ color: 'white' }} />
        </Fab>
        <div>
          {isMobile ? (
            users.map((user) => (
              <Card key={user.id} style={{ marginBottom: '16px' }}>
                <CardContent>
                  <Typography variant="h6">
                    {user.firstName} {user.lastName}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Email: {user.email}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Date de naissance: {user.birthday}
                  </Typography>
                </CardContent>
                <CardActions>
                  <IconButton
                    aria-label="Edit"
                    onClick={() => handleEditStudent(user)}
                  >
                    <EditIcon />
                  </IconButton>
                </CardActions>
              </Card>
            ))
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Prénom</TableCell>
                    <TableCell>Nom</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Date de naissance </TableCell>
                    <TableCell>Activation</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>{user.firstName}</TableCell>
                      <TableCell>{user.lastName}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.birthday}</TableCell>
                      <TableCell>
                        <Switch
                          checked={user.isActive}
                          onChange={() => {
                            if (user.isActive) {
                              handleDeactivateStudent(user);
                            } else {
                              handleActivateStudent(user);
                            }
                          }}
                        />
                    </TableCell>
                      <TableCell>
                        <IconButton
                          aria-label="Edit"
                          onClick={() => handleEditStudent(user)}
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
      <AddUserModal
        open={isAddUserModalOpen}
        onClose={handleCloseAddUserModal}
        onSave={handleSaveUser}
        uid={uid}
        isEdit={isToEdit}
        userToEdit={studentToEdit}
      />
      <ToastContainer />
      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
    </div>
  );
}

export default UniversityDetails;
